import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CotizacionDesc } from "../../../../Pages/Auto/Precios";
import { SegTooltip } from "../../../SegUI/SegTooltip/SegTooltip";
import { useGraciasStore } from "../../../../Services/Providers/GraciasStore";
import { ModalDescripcion } from "./ModalDescripcion";
import { OffCanvas } from "./OffCanvas";
import { useEmisionStore } from "../../../../Services/Providers/EmisionStore";
import { useConfiguracionEmpresa } from "../../../../Services/Providers/useConfiguracionEmpresa";
import { updateEmisionStep } from "../../../../Services/API/bff/auto";
import { autoViaBffDesdeConfig } from "../../../../Services/API/bff/auto/flag";
import { seleccionarPlan } from "../../../../Services/API/bff/auto/funnel";
import { aBffError, BffError } from "../../../../Services/API/bff/auto/bffError";
import { mensajeDeError } from "../../../../Services/API/bff/auto/errorMessages";
import { RechazoEmbudo } from "../Emision/RechazoEmbudo";
import { useCotizacionStore } from "../../../../Services/Providers/CotizacionStore";
import { useConfig } from "../../../../context/ConfigContext";

interface ModalPreciosProps {
    cotizacionDesc: CotizacionDesc
    isEmision?: boolean
    rubro?: string;
    /** Solo /retomar: precios vencidos, no se puede contratar hasta actualizarlos. */
    deshabilitado?: boolean;
    /** Solo /retomar: trae los datos de la persona antes de seleccionar. false = no sigue. */
    antesDeContratar?: (itemId: string) => Promise<boolean>;
    /** Solo /retomar: la selección falló; true = la pantalla lo resuelve y no se navega. */
    alFallarSeleccion?: (error: BffError) => boolean;
}

export const ModalPrecios = ({ cotizacionDesc, isEmision = false, rubro = "Auto", deshabilitado = false, antesDeContratar, alFallarSeleccion }: ModalPreciosProps) => {
    const { setGraciasValues } = useGraciasStore();
    const { emisionValues } = useEmisionStore();
    const cotizacionValues = useCotizacionStore(state => state.cotizacionValues);
    const { compania } = useParams();
    const [indiceAbierto, setIndiceAbierto] = useState<number | null>(null);
    const { origen, config } = useConfiguracionEmpresa();
    const { config: envConf } = useConfig();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    /** 422 del embudo al elegir el plan: no se sigue a la emision. */
    const [rechazoEmbudo, setRechazoEmbudo] = useState<string>();
    const navigate = useNavigate();

    useEffect(() => {
        setIndiceAbierto(-1)
    }, [cotizacionDesc]);


    const handleClick = (indice: number) => {
        setIndiceAbierto(prevIndice => (prevIndice === indice ? null : indice));
    };

    const handleSubmit = async (e: any, direccion: string, gracias: boolean = false) => {
        e.preventDefault();
        if (isLoading || deshabilitado) return
        document.body.style.cssText = "";

        setIsLoading(true)

        if (antesDeContratar && !(await antesDeContratar(String(emisionValues.cotizacionDesc?.id)))) {
            setIsLoading(false)
            return
        }

        let destino = direccion;
        let derivaAGracias = gracias;
        setRechazoEmbudo(undefined)

        if (autoViaBffDesdeConfig(envConf)) {
            try {
                const seleccion = await seleccionarPlan(
                    rubro.toLowerCase() === "moto" ? "moto" : "auto",
                    String(emisionValues.cotizacionDesc!.id)
                );
                if (!seleccion.emisionOnline.habilitada) {
                    derivaAGracias = true;
                    destino = compania
                        ? `/${rubro.toLocaleLowerCase()}/gracias/${compania}`
                        : `/${rubro.toLocaleLowerCase()}/gracias/`;
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn("[auto_via_bff] selección:", aBffError(error).code);
                // Embudo EOL (US 23704): Salesforce rechazo cotizacion_elegida. Frena.
                if (aBffError(error).code === "embudo_rechazado") {
                    setRechazoEmbudo(mensajeDeError(aBffError(error)))
                    setIsLoading(false)
                    return
                }
                // Solo /retomar: un rechazo que la pantalla resuelve (p. ej. precios vencidos) corta acá.
                if (alFallarSeleccion?.(aBffError(error))) {
                    setIsLoading(false)
                    return
                }
            }
        } else {
            //if (origen === "SEGURARSE") {
            await updateEmisionStep(0, {
                idItemCotizacion: emisionValues.cotizacionDesc!.id,
                contactoId: cotizacionValues.contactoId,
            } as any)
            //}
        }
        setIsLoading(false)

        if (derivaAGracias) {
            setGraciasValues(cotizacionDesc?.companyName)
        }
        navigate(destino);
    }

    return (
        <div>
            <OffCanvas abrirPrimeraCarga={emisionValues.cotizacionDesc ? true : false} className={isEmision === false ? "offcanvas offcanvas-end oc-cob" : "offcanvas offcanvas-end oc-cob oc-cob1"}>
                {isEmision === false ? <div className="oc-sum ">
                    <div className="cobertura">{cotizacionDesc?.planName}</div>
                    <div className="empresa">
                        <img src={cotizacionDesc?.companyLogo} alt={cotizacionDesc?.companyName} loading="lazy" />
                    </div>
                    <div className="descuento">
                        <span className="antes">{"$" + cotizacionDesc?.discountAmount}</span>
                        {/* <span className="ahora">{"-" + discountPerc + "%"}</span> */}
                    </div>
                    <div className="precio">
                        <span className="monto">{"$" + cotizacionDesc?.amountMonth}</span>
                        <span className="periodo">{envConf.pais === "UY" ? " /año" : " /mes"}</span>
                    </div>
                    {!isEmision && (
                        <div className="cta">
                            {(origen !== "SEGURARSE" || (rubro !== "Auto" && rubro !== "Moto")) ?
                                <a href={compania ? (`/${rubro.toLowerCase()}/gracias/` + compania) : `/${rubro.toLowerCase()}/gracias/`}
                                    type="button"
                                    onClick={(e) =>
                                        handleSubmit(e, (compania ? (`/${rubro.toLowerCase()}/gracias/` + compania) : `/${rubro.toLowerCase()}/gracias/`), true)
                                    }
                                    className={`btn btn-primary${deshabilitado ? " disabled" : ""}`}
                                    aria-disabled={deshabilitado || undefined}
                                    style={origen !== "SEGURARSE" ? { backgroundColor: config.colors.primary } : {}}>
                                    <span>CONTRATAR</span>
                                    {isLoading &&
                                        <div className="spinner-border spinner-border-sm " role="status">
                                            <span className="sr-only" />
                                        </div>
                                    }
                                </a>
                                :
                                <div>
                                    <a
                                        href={cotizacionDesc.id ? `/${rubro.toLowerCase()}/emision/revision` : `/${rubro.toLowerCase()}/gracias/${compania ? compania : ""}`}
                                        type="button"
                                        className={`btn btn-primary${deshabilitado ? " disabled" : ""}`}
                                        aria-disabled={deshabilitado || undefined}
                                        onClick={(e) => handleSubmit(e, cotizacionDesc.id ? `/${rubro.toLowerCase()}/emision/revision` : `/${rubro.toLowerCase()}/gracias/${compania ? compania : ""}`, cotizacionDesc.id ? false : true)}
                                    //style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "8px" }}
                                    >
                                        <span className="mx-2">
                                            CONTRATAR
                                        </span>
                                        {isLoading &&
                                            <div className="spinner-border spinner-border-sm" role="status">
                                                <span className="sr-only" />
                                            </div>
                                        }
                                    </a>
                                </div>
                            }
                            <RechazoEmbudo mensaje={rechazoEmbudo} />
                        </div>
                    )}
                    {
                        origen === "SEGURARSE" &&
                        <div className="cta-wa d-none d-lg-block">
                            <p>¿Tenés dudas sobre esta cobertura?</p>
                            <a href={encodeURI(`https://wa.me/${envConf.pais === "UY" ? "59892281806" : "5491128357048"}?text=¡Hola! Me interesa saber más de la cobertura ` + (cotizacionDesc?.planName! || null) + " de la Aseguradora " + (cotizacionDesc?.companyName! || null) + ". Quiero hablar con un asesor.")} target='_blank' rel='noreferrer'><span>Consultanos</span> <svg className="icon"><use xlinkHref="#whatsapp" /></svg></a>
                        </div>
                    }

                    {
                        envConf.pais === "AR" &&
                        <div className="datafiscal d-none d-lg-flex">
                            <div><img src={cotizacionDesc?.fiscalInfoImg} width="30" alt='Información fiscal' /></div>
                            <p>Segurarse Asesores de Seguros S.A., Matrícula registrada 1174, expedida por la Superintendencia de Seguros de la Nación (www.ssn.gov.ar 4338-4000 o 0800-666-8400)</p>
                        </div>
                    }
                </div> : ""}
                <div className={isEmision === false ? "oc-det" : "oc-det oc-det1"}>

                    <div className="suma">
                        La cobertura incluye <br />
                        {
                            envConf.pais === "AR" &&
                            <>
                                <span style={{ color: origen !== "" ? config.colors.tertiary : "" }}>
                                    Suma asegurada: ${cotizacionDesc?.sumaAsegurada}</span>
                                <SegTooltip text="Es el monto máximo de indemnización. En caso de un siniestro total (por ejemplo, ante el robo del vehículo).​" placement="bottom-end" />
                            </>
                        }
                    </div>
                    <div className={`accordion accordion-flush acc-01`} id="accDetalle">
                        {cotizacionDesc?.descList && cotizacionDesc?.descList.map((desc, index) =>
                            <ModalDescripcion
                                key={index}
                                nombre={desc.Nombre}
                                descripcion={desc.Descripcion}
                                isOpen={index === indiceAbierto}
                                toggleDesplegable={() => handleClick(index)}
                            />
                        )}
                    </div>
                    {
                        origen === "SEGURARSE" &&
                        <div className="cta-wa d-lg-none">
                            <p>¿Tenés dudas sobre esta cobertura?</p>
                            <a href={encodeURI(`https://wa.me/${envConf.pais === "UY" ? "59892281806" : "5491128357048"}` + "?text=¡Hola! Me interesa saber más de la cobertura " + (cotizacionDesc?.planName! || null) + " de la Aseguradora " + (cotizacionDesc?.companyName! || null) + ". Quiero hablar con un asesor.")} target='_blank' rel='noreferrer'><span>Consultanos</span> <svg className="icon"><use xlinkHref="#whatsapp" /></svg></a>
                        </div>
                    }
                    {
                        envConf.pais === "AR" &&
                        <div className="datafiscal d-lg-none">
                            <div><img src={cotizacionDesc?.fiscalInfoImg} width="30" alt="Información fiscal" /></div>
                            <p>Segurarse Asesores de Seguros S.A., Matrícula registrada 1174, expedida por la Superintendencia de Seguros de la Nación (www.ssn.gov.ar 4338-4000 o 0800-666-8400)</p>
                        </div>
                    }
                </div>

            </OffCanvas>
        </div>
    );
}

export default ModalPrecios;
